export default "__VITE_ASSET__af014bde__"